export const DEFAULT_QUOTE_SECTION = '10';
// 普货、普挑、精挑、挑膏
export const QUOTE_SECTION = {
  [DEFAULT_QUOTE_SECTION]: '普货',
  20: '普挑',
  30: '精挑',
  40: '挑膏',
};
// 页面类型
export const PAGE_TYPES = {
  MP_POPUP: { value: 'mp_popup', text: '小程序-弹窗' },
  MP_HOME: { value: 'mp_home', text: '小程序-首页上方' },
  MP_MARKETCENTER: { value: 'mp_marketCenter', text: '小程序-行情中心' },
  MP_1: { value: 'mp_crayfish', text: '小程序-小龙虾行情' },
  MP_2: { value: 'mp_crab', text: '小程序-大闸蟹行情' },
  MP_3: { value: 'mp_eel', text: '小程序-黄鳝行情' },
  MP_4: { value: 'mp_loach', text: '小程序-泥鳅行情' },
  MP_5: { value: 'mp_turtle', text: '小程序-甲鱼行情' },
  MP_6: { value: 'mp_spiral', text: '小程序-螺行情' },
  MP_CONNECTION: { value: 'mp_connection', text: '小程序-人脉圈子列表' },
  MP_REQUIREMENT: { value: 'mp_requirement', text: '小程序-买卖信息列表' },
  MP_WHOLESALEMARKET: { value: 'mp_originMarket', text: '小程序-批发市场列表' },
  MP_ORIGINENTERPRISE: { value: 'mp_originEnterprise', text: '小程序-源头企业列表' },
  MP_BLACKLIST: { value: 'mp_blacklist', text: '小程序-黑名单' },
  MP_STORE: { value: 'mp_store', text: '小程序-门店列表' },
};
//  公告类型（位置）
export const NOTICE_TYPES = [
  PAGE_TYPES.MP_HOME,
  PAGE_TYPES.MP_MARKETCENTER,
  PAGE_TYPES.MP_1,
  PAGE_TYPES.MP_2,
  PAGE_TYPES.MP_3,
  PAGE_TYPES.MP_4,
  PAGE_TYPES.MP_5,
  PAGE_TYPES.MP_6,
  PAGE_TYPES.MP_CONNECTION,
  PAGE_TYPES.MP_REQUIREMENT,
  PAGE_TYPES.MP_STORE,
  PAGE_TYPES.MP_WHOLESALEMARKET,
  PAGE_TYPES.MP_ORIGINENTERPRISE,
  PAGE_TYPES.MP_BLACKLIST,
];
// 广告/轮播类型（位置）
export const SWIPER_TYPES = [
  PAGE_TYPES.MP_POPUP,
  PAGE_TYPES.MP_HOME,
  PAGE_TYPES.MP_MARKETCENTER,
  PAGE_TYPES.MP_1,
  PAGE_TYPES.MP_2,
  PAGE_TYPES.MP_3,
  PAGE_TYPES.MP_4,
  PAGE_TYPES.MP_5,
  PAGE_TYPES.MP_6,
  PAGE_TYPES.MP_CONNECTION,
  PAGE_TYPES.MP_REQUIREMENT,
  PAGE_TYPES.MP_STORE,
  PAGE_TYPES.MP_WHOLESALEMARKET,
  PAGE_TYPES.MP_ORIGINENTERPRISE,
  PAGE_TYPES.MP_BLACKLIST,
];
export const QUOTE_TYPE_MAPPING = {
  1: {
    name: '小龙虾',
    shortName: '虾',
    code: 'longxia',
    iconCode: 'xia',
    dictCode: 'crayfish',
    min: 3,
    max: 200,
    requiredFileds: ['categorycode', 'weightcode', 'price'],
    ignoreCateCodes: ['1019', '1020'],
  },
  2: {
    name: '大闸蟹',
    shortName: '蟹',
    code: 'pangxie',
    iconCode: 'xie',
    dictCode: 'crab',
    min: 4,
    max: 300,
    requiredFileds: ['categorycode', 'weightcode', 'price'],
    ignoreCateCodes: ['1019', '1020'],
  },
  3: {
    name: '黄鳝',
    code: 'huangshan',
    iconCode: 'huangshan',
    dictCode: 'eel',
    min: 0,
    max: 99999,
    requiredFileds: [],
    ignoreCateCodes: [],
  },
  4: {
    name: '泥鳅',
    code: 'niqiu',
    iconCode: 'niqiu',
    dictCode: 'loach',
    min: 0,
    max: 99999,
    requiredFileds: [],
    ignoreCateCodes: [],
  },
  5: {
    name: '甲鱼',
    code: 'jiayu',
    iconCode: 'jiayu',
    dictCode: 'turtle',
    min: 0,
    max: 99999,
    requiredFileds: [],
    ignoreCateCodes: [],
  },
  6: {
    name: '螺',
    code: 'luo',
    iconCode: 'luo',
    dictCode: 'luo',
    min: 0,
    max: 99999,
    requiredFileds: [],
    ignoreCateCodes: [],
  },
};
